import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path clipRule="evenodd" d="M12 1.155L5.026 9.06.646 4.68l.708-.781 3.62 3.6L11.122.4l.878.755z" /></svg>;